<template>
  <div id="landing-container" class="flex flex-col items-center justify-center pb-4">
    <div class="flex flex-col items-center justify-center gap-4 px-4 pt-8">
      <h1 class="text-center text-[32px] font-bold text-[#484849]">{{ userWelcomeText }}</h1>
      <p class="text-center text-base font-bold text-[#747474]">
        {{ translate('Home.Subtitle') }}
      </p>
    </div>
    <div
      id="modules-container"
      class="z-10 mt-12 grid w-full justify-items-center gap-6 px-4 md:max-w-6xl"
    >
      <v-card
        v-for="group in workspaceAppGroups"
        :key="group.name"
        :data-testid="`module-${group.name.toLowerCase()}`"
        class="module-card w-full !rounded-radius-mr bg-white lg:max-w-[360px]"
      >
        <div class="flex flex-col gap-4 p-4">
          <div class="flex items-center gap-4">
            <v-icon color="#747474" size="32" :icon="group.config.icon" />
            <h2 class="text-xl font-black text-[#303030]">
              {{ translate(group.config.nameKey) }}
            </h2>
          </div>
          <p class="min-h-10 text-sm text-[#747474]">
            {{ translate(group.config.descriptionKey) }}
          </p>
          <div class="flex flex-wrap items-start gap-7">
            <template v-for="item in group.apps" :key="item.name">
              <app-link :app-data="item" />
            </template>
          </div>
        </div>
      </v-card>
    </div>
  </div>
  <home-footer />
</template>

<script setup lang="ts">
import AppLink from '@/components/AppLink/AppLink.vue'
import HomeFooter from '@/components/HomeFooter/HomeFooter.vue'
import { computed, onBeforeMount } from 'vue'
import { useSettingsStore } from '@/store'
import { useTranslator } from '@/plugins/translations'
import { auth } from '@/plugins'
const { getUserProfile } = auth.useAuthentication()

const store = useSettingsStore()
const { translate } = useTranslator()
const workspaceAppGroups = computed(() => store.groupedApps)

const userWelcomeText = computed(() => {
  return `${translate('App.Greeting')}, ${getUserProfile()?.given_name ?? getUserProfile()?.name}`
})

onBeforeMount(async () => {
  const settingsStore = useSettingsStore()
  await settingsStore.getApplications()
})
</script>

<style scoped>
* {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.module-card {
  box-shadow: var(--shadow-s);
}

#landing-container {
  min-height: 60vh;
}

#modules-container {
  grid-template-columns: repeat(auto-fit, minmax(20rem, 1fr));
}

#modules-container div {
  animation: fadeIn 0.25s ease-in;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
</style>
